import { DETAIL_OUTLET, GALLERY_MODAL, INITIAL_OUTLET } from "./types";

const initiate = {
    outlets: [],
    detail: null,
    galleryOpen: false,
    gallery: null,
}

const StoreReducer = (state = initiate, action) => {
    switch (action.type) {
        case INITIAL_OUTLET:
            return {
                ...state,
                ...action.payload,
            };
        case DETAIL_OUTLET:
            return {
                ...state,
                ...action.payload,
            };
        case GALLERY_MODAL:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export default StoreReducer;